import { withStyles } from '@material-ui/core';

import DnDUploader from './component';
import styles from './styles';

export default withStyles(styles)(DnDUploader);
